var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"transition":"","content":_vm.content,"placement":"top","effect":"light","enterable":false}},[_vm._v(" "+_vm._s(_vm.content)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }